import connectAsync from '../../../utils/connectAsync';
import { unauthenticateUser } from './../../../actions/auth';
import DataRequestAuthRoute from './DataRequestAuthRoute';

export default connectAsync([unauthenticateUser])(DataRequestAuthRoute);
